import React from 'react';
import PropTypes from 'prop-types';
import styles from './featured-item.module.scss';

const FeaturedItem = ({item}) => {
  return (
    <a href={item.link.url} className={styles.featured}>
      <img src={item.link.image_src}></img>
      <h4 className={styles.heading}>{item.link.linkText}</h4>
      <p className={styles.content} dangerouslySetInnerHTML={{__html: item.link.description}} />
      <span className={styles.date}>{item.link.published_at}</span>
    </a>
  )
}

FeaturedItem.propTypes = {
  item: PropTypes.any.isRequired
}

export default FeaturedItem;
